"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = Toast;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("..");
const utils_1 = require("../../utils");
const ToastContext_1 = require("./ToastContext");
function Toast() {
    const { setNotice, notice } = (0, ToastContext_1.useToastContext)();
    const tid = (0, utils_1.useTestIds)({}, "toast");
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: notice && (0, jsx_runtime_1.jsx)(components_1.Banner, { ...notice, ...tid, onClose: () => setNotice(undefined) }) });
}
